import { FC } from "react";
import { Box } from "@chakra-ui/react";
import { Header } from "@/components/Header";
import { Seo } from "@/components/Seo";
import {
  OrganizationSchema,
  SoftwareApplicationSchema,
  WebSiteSchema,
} from "@/components/StructuredData";
import { HeroSection } from "@/components/HeroSection";
// import { ClientsSection } from "@/components/ClientsSection";
import { FeaturesGrid } from "@/components/FeaturesGrid";
import { HowItWorks } from "@/components/HowItWorks";
import { WidgetShowcase } from "@/components/WidgetShowcase";
import { LiveDemos } from "@/components/LiveDemos";
import { IntegrationsSection } from "@/components/IntegrationsSection";
import { PlatformIntegration } from "@/components/IntegrationCard/PlatformIntegration";
import { CodeSnippetIntegration } from "@/components/IntegrationCard/CodeSnippetIntegration";
import { CtaSection } from "@/components/CtaSection";
import { PublicLayout } from "@/layouts/PublicLayout";
import { HomeContent, Locale, SUPPORTED_LOCALES } from "@/constants/landingPages";

interface HomeProps {
  content: HomeContent;
  locale: Locale;
}

export const Home: FC<HomeProps> = ({ content, locale }) => {
  const baseUrl = process.env.NEXT_PUBLIC_URL || "https://flexibooking.sk";
  const currentUrl = `${baseUrl}/${locale}`;

  // Generate hreflang tags for all supported locales
  const hreflangs = SUPPORTED_LOCALES.map((loc) => ({
    locale: loc,
    url: `${baseUrl}/${loc}`,
  }));

  return (
    <PublicLayout>
      <Seo
        title={content.meta.title}
        description={content.meta.description}
        url={currentUrl}
        canonical={currentUrl}
        hreflangs={hreflangs}
      />

      {/* Structured Data for SEO */}
      <OrganizationSchema />
      <SoftwareApplicationSchema />
      <WebSiteSchema />

      <Header bg="white" isWithBreadcrumbs={false} locale={locale} content={content} />
      <Box as="main">
        <HeroSection content={content.hero} locale={locale} />
        {/* <ClientsSection /> */}
        <FeaturesGrid content={content.features} />
        <HowItWorks content={content.howItWorks} />
        <WidgetShowcase content={content.widgetShowcase} />
        <LiveDemos locale={locale} />
        <IntegrationsSection content={content.integrations}>
          <PlatformIntegration
            id="goodbarber"
            locale={locale}
            content={content.integrations.items.goodbarber}
          />
          <PlatformIntegration
            id="elementor"
            locale={locale}
            content={content.integrations.items.elementor}
          />
          <CodeSnippetIntegration
            content={content.integrations.items.customCode}
          />
        </IntegrationsSection>
        <CtaSection content={content.cta} locale={locale} />
      </Box>
    </PublicLayout>
  );
};
